import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAdmin, selectCurrentUser } from '../store/slices/authSlice';

function AdminRoute() {
  const isAdmin = useSelector(selectIsAdmin);
  const currentUser = useSelector(selectCurrentUser);

  // Debug log
  console.log('AdminRoute - Current User:', currentUser);
  console.log('AdminRoute - Is Admin:', isAdmin);
  console.log('AdminRoute - User Role:', currentUser?.role);

  if (!isAdmin) {
    console.log('❌ Access denied - Not admin');
  } else {
    console.log('✅ Access granted - Is admin');
  }

  return isAdmin ? <Outlet /> : <Navigate to="/" replace />;
}

export default AdminRoute;
